/* eslint-disable */
import * as React from "react";
import OrbitIcon from "../Icon";
export default function ArrowUp(props) {
  var color = props.color,
      size = props.size,
      customColor = props.customColor,
      className = props.className,
      dataTest = props.dataTest,
      ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      reverseOnRtl = props.reverseOnRtl;
  return React.createElement(OrbitIcon, {
    viewBox: "0 0 24 24",
    size: size,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    d: "M16.566 6.226l-3.982-3.982a.833.833 0 0 0-1.179 0l-3.98 3.982a.831.831 0 0 0-.245.59c0 .46.373.833.833.833h2.524c.115 0 .208.093.208.208V20.75a1.25 1.25 0 1 0 2.5 0V7.855a.207.207 0 0 1 .208-.206h2.522a.835.835 0 0 0 .77-.515.835.835 0 0 0-.179-.908"
  }));
}